import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getValueFromQueryString, extractIdentityObjectFromIdentifier } from '../../util/sharedFunctions';
import Controls from '../../util/controls';


class AutoLogin extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { loginAction } = this.props;

    setTimeout(function () {
      loginAction(this.props.values);
    }.bind(this), 1000);
  }

  render() {
    return (
      <div className="text-center client-text">
        <h4>Authenticating...</h4>
        <Controls.LoadingPanel />
      </div>
    );
  }
}



let mapStateToProps = function (state, ownProps) {
  let code = getValueFromQueryString(ownProps.location.search, 'code');//cuz the .query strips the '+' characters we have to get the 'code' the hard way
  let redirectUrl = getValueFromQueryString(ownProps.location.search, 'redirectUrl');
  let identity = getValueFromQueryString(ownProps.location.search, 'identity');//cuz the .query strips the '+' characters we have to get the 'code' the hard way
  let identityObject = extractIdentityObjectFromIdentifier(identity);

  return {
    values: {
      userName: identityObject.userName,
      userId: identityObject.userId,
      code: code,
      jobId: identityObject.jobId,
      merchantId: identityObject.merchantId,
      passcode: identityObject.passcode,
      redirectUrl: redirectUrl
    }
  };
};

export default connect(mapStateToProps)(AutoLogin);





// WEBPACK FOOTER //
// ./app/auth/components/autoLogin.js